<template>
  <div class="mt-4">
    <div class="form-control pa-1" :class="{ 'has-error': errors.has(`titleName`) }">
      <label>{{ $t('topic_name') }}</label>
      <input
        :data-vv-as="$t('titleName')"
        v-model="value.titleName"
        :name="`titleName`"
        class="form-control mr-3"
        type="text"
        maxlength="50"
      />
      <span class="text-error" v-if="errors.has(`titleName`)">{{ errors.first(`titleName`) }}</span>
    </div>
    <div v-for="(item, index) of data" :key="index">
      <!-- <v-layout
        wrap
        v-if="!item.toggle"
        class="intent-item z-border-red"
        style="padding: 4px 15px 0px;"
      >

      </v-layout> -->

      <v-layout wrap class="intent-item z-border-red pa-2">
        <template>
          <v-flex xs2>
            <uploadfile
              :height="47"
              :backGroundAuto="true"
              v-model="item.image"
              data-vv-as="Stock Image"
            >
              <v-btn flat fab small>
                <v-icon small>camera_alt</v-icon>
              </v-btn>
            </uploadfile>
          </v-flex>
          <v-flex xs6 style="align-self: center; padding-left: 15px;">
            <template>{{ item.title }}</template>
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            <template>
              <toggle-button
                class="mt-3"
                :value="item.status"
                :sync="true"
                :color="$vuetify.theme.success"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
                @change="item.status = !item.status"
              />
            </template>

            <span @click="onClickToggle(index)" style="cursor: pointer">
              <v-icon v-if="!item.toggle">keyboard_arrow_down</v-icon>
              <v-icon v-else>keyboard_arrow_up</v-icon>
            </span>
          </v-flex>
        </template>
        <!-- <v-flex xs2>
          <uploadfile
            ref="answer"
            v-model="item.image"
            :height="50"
            data-vv-as="Image"
            :data-vv-name="'answer_' + '_image_'"
            v-validate
          ></uploadfile>
        </v-flex> -->
        <template v-if="item.toggle">
          <v-flex xs10>
            <div class="form-control pa-1" :class="{ 'has-error': errors.has(`title`) }">
              <!-- <label>ชื่อ</label> -->
              <input
                :data-vv-as="$t('title')"
                v-model="item.title"
                :name="`title`"
                class="form-control mr-3"
                type="text"
                maxlength="50"
              />
              <span class="text-error" v-if="errors.has(`title`)">{{ errors.first(`title`) }}</span>
            </div>

            <small for="points">{{ $t('Link') }} ( {{ $t('only_use_https') }})</small>
            <div class="form-control" :class="{ 'has-error': errors.has('buttonLink') }">
              <textarea
                name="buttonLink"
                key="button-link"
                :data-vv-name="'buttonLink'"
                rows="10"
                class="form-control"
                style="width: 100%; resize: vertical; height: 50px;"
                v-model="item.url"
                :data-vv-as="$t('Link')"
                v-validate="'isUrl'"
                placeholder="https://www.website.com"
                maxlength="50"
              ></textarea>
              <span class="text-error" v-show="errors.has('buttonLink')">{{
                errors.first('buttonLink')
              }}</span>
            </div>

            <div v-if="item.borderColor">
              {{ $t('frame_color') }}
              <v-menu top :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outline v-bind="attrs" v-on="on">
                    <span class="foo" :style="`background: ${item.borderColor.hex}`"></span>
                    {{ item.borderColor.hex }}
                  </v-btn>
                </template>

                <sketch-picker v-model="item.borderColor" />
              </v-menu>
            </div>
            <div v-if="item.fontColor">
              {{ $t('font_color') }}
              <v-menu top :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outline v-bind="attrs" v-on="on">
                    <span class="foo" :style="`background: ${item.fontColor.hex}`"></span>
                    {{ item.fontColor.hex }}
                  </v-btn>
                </template>

                <sketch-picker v-model="item.fontColor" />
              </v-menu>
            </div>
          </v-flex>
        </template>
      </v-layout>

      <!-- <span>{{ $t('set_youtube_play') }}</span>
    <v-checkbox
      class="mt-0"
      v-model="value.autoplay"
      color="primary"
      :label="$t('auto_play')"
    ></v-checkbox>
    <v-checkbox
      class="mt-0"
      v-model="value.loop"
      color="primary"
      :label="$t('set_loop')"
    ></v-checkbox> -->
    </div>
  </div>
</template>

<script>
import { Sketch } from 'vue-color'
import uploadfile from '@/components/elements/uploadfile'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  props: ['value'],
  data() {
    return {
      data: []
    }
  },
  components: {
    'sketch-picker': Sketch,
    uploadfile,
    ToggleButton
  },
  mounted() {
    if (this.value && this.value.list.length > 0) {
      this.value.list.map(item => {
        item.toggle = false
        this.data.push(item)
      })
    }
  },
  methods: {
    onClickToggle(index) {
      this.data[index].toggle = !this.data[index].toggle
    }
  }
}
</script>

<style lang="scss" scoped>
.foo {
  float: left;
  width: 20px;
  height: 20px;
  margin: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/salePage/templateType/SocialLink.vue